import { AllowanceStep } from '@app/pages/allowance/allowance';
import { Tool } from '@app/shared/utils';
import { createAction, props } from '@ngrx/store';
/**
 * Action dispatched to set the current step
 */
export const setAllowanceStep = createAction('[Allowance] Set Step', props<{ tool?: Tool; step: AllowanceStep }>());
/**
 * Action dispatched to reset to the first step after leaving rationing but without reseting information (for personalised bag)
 * and without routing side effects that are triggered by the setAllowanceStep action
 */
export const resetAllowanceStepToFirst = createAction('[Allowance] Reset Step To First');
/**
 * Reset allowance params
 */
export const resetAllowanceParams = createAction('[Allowance] Reset Allowance Params');
/**
 * Reset allowance store data
 */
export const resetAllowance = createAction('[Allowance] Reset');
